// removed by extract-text-webpack-plugin
module.exports = {"row":"SitemapLinks-style__row__9332e0c4","item":"SitemapLinks-style__item__9332e0c4","link":"SitemapLinks-style__link__9332e0c4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LinkRow/SitemapLinks-style.scss
// module id = ./src/components/Footer/LinkRow/SitemapLinks-style.scss
// module chunks = 13